import { environment } from "../../../../../src/environments/environment";
import { EventEmitter, Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http";
import { UserService } from "../../auth/_services/user.service";
import moment from "moment";
const API_TAG_URL = '/api/iow';
const API_URL = environment.API_URL;

@Injectable({
    providedIn: 'root'
})

export class IOWService {
    alertTagListChanged = new EventEmitter<any>();
    dateRangeChanged = new EventEmitter<any>();
    subTypeChanged = new EventEmitter<any>();
    systems = [];
    facility: any;
    units: any;
    alerts:any = {};
    queryTags: any = [];
    selectedIssueFromQueryParam: string = '';
    selectedCollabId: string = '';
    caseStatus: any = {};
    constructor(private readonly http: HttpClient,
        private readonly userService: UserService
    ) { }
    dateRange = [
        {
            id: 1,
            name: 'Yesterday'
        },
        {
            id: 2,
            name: 'Last 24 Hours'
        },
        {
            id: 3,
            name: 'Last 7 Days',
        },
        {
            id: 4,
            name: 'Last 14 Days',
        },
        {
            id: 5,
            name: 'Last 30 Days',
        },
        {
            id: 6,
            name: 'Last 60 Days',
        },
        {
            id: 7,
            name: 'Last 180 Days',
        },
        {
            id: 8,
            name: 'Last 1 Year',
        }
    ];

    selectedDateRange = {
        id: 1,
        name: 'Yesterday',
    }
    subType = [
        {
            id :  24 ,
            name:'High',
            color:"#E74D1D",
        },
        {
            id :   23 ,
            name:"H3",
            color: "#F39657",
        },
        {
            id :  22 ,
            name:'H2',
            color: "#FBC781",
        },
        {
            id :   21 ,
            name:"H1",
            color: "#FEE198",
        },
        {
            id :  11 ,
            name:'L1',
            color: "#A3DFF7",
        },
        {
            id :   12 ,
            name:"L2",
            color: "#3EBDEE",
        },
        {
            id :  13 ,
            name:'L3',
            color: "#4782D1",
        },
        {
            id :   14 ,
            name:"Low",
            color: "#7256A4",
        },
    ]
    getSubType(id:number){
        if (id) {
            return this.subType.find(st=> st.id == id)
        }
        return this.subType;
    }

    getCriticality(tag, type){
        if (tag.iowCriticalityNew?.lower || tag.iowCriticalityNew?.upper) {
            return type == 1 ? tag.iowCriticalityNew.lower : tag.iowCriticalityNew.upper;
        }
        return tag.iowCriticality || 1
    }
    subTypeAndCriticality = [24, 23, 22, 21, 11, 12, 13, 14]
    getIOWMetrix(systems, timeRange, type = 5, activeExceedance = false, isSummary = false, tagList = [], customDate = [], fields = '') {
        let range:any = this.getDateRange(timeRange)
        if (customDate?.length) {
            range = {
                from: customDate[0],
                to: customDate[1]
            }
        }
        let params = {
            ...range,
            activeExceedance: activeExceedance,
            summary: isSummary,
            filter: {
                system: systems,
                type: [type]
            }
        }
        if (tagList.length) {
            params.filter["tag"] = tagList
        }
        if (fields) {
            params["fields"] = fields
        }
        return this.http.post(`${API_URL}${API_TAG_URL}`, params, { headers: this.userService.getHttpAuthHeader() });
    }

    downloadIowCsv(systems, range, duration, type = 5) {
        let params = {
            ...range,
            filter: {
                system: systems,
                type: [type]
            },
            csv: true,
            ...(duration ? { duration } : {})
        }
        return this.http.post(`${API_URL}${API_TAG_URL}`, params, { headers: this.userService.getHttpAuthHeader(), responseType: 'text' });
    }

    getDateRange(timeRange){
        let range = {
            from: moment(),
            to: moment()
        }
        switch (timeRange) {
            case 1:
                range.from = moment().subtract(1, 'days').startOf('day');
                range.to = moment().subtract(1, 'days').endOf('day');
                break;
            case 2:
                range.from = moment().subtract(24, 'hours');
                break;
            case 3:
                range.from = moment(range.to).subtract(7, 'days');
                break;
            case 4:
                range.from = moment(range.to).subtract(14, 'days');
                break;
            case 5:
                range.from = moment(range.to).subtract(30, 'days');
                break;
            case 6:
                range.from = moment(range.to).subtract(60, 'days');
                break;
            case 7:
                range.from = moment(range.to).subtract(180, 'days');
                break;
            case 8:
                range.from = moment(range.to).subtract(365, 'days');
                break;
            default:
                range.from = moment().subtract(1, 'days').startOf('day');
                range.to = moment().subtract(1, 'days').endOf('day');
                break;
        }
        return range
    }
    extractUniqueUnits(user) {
        const units = [];
        this.systems.forEach(sys => {
          const isUnitNotExist = units.every(unit => unit?._id !== sys.unit?._id);
          if ((user.admin || user.unit.includes(sys.unit?._id)) && isUnitNotExist) {
            units.push(sys?.unit);
          }
        });
        return units;
      }

      filterSystemsByUser(systems: any[], units: any[], user: any): any[] {
        return systems.filter(system => {
          const isUserSystem = user.system.indexOf(system?._id) > -1;
          const isUnitMatch = units.length ? units.includes(system.unit?._id) : true;
          return isUserSystem && isUnitMatch;
        });
      }
}
